import { apiGet, apiPut, apiPost } from './client';
import type { Lead, LeadDetail, LeadStatus, ActivityType } from '@/types';

export interface LeadsResponse {
  leads: Lead[];
  total: number;
  page: number;
  page_size: number;
}

export interface LeadsParams {
  page?: number;
  page_size?: number;
  search?: string;
  status?: string;
}

export interface UpdateLeadData {
  status?: LeadStatus;
  phone?: string;
  budget?: string;
  timeline?: string;
  notes?: string;
}

export interface LogActivityData {
  activity_type: ActivityType;
  description: string;
}

export async function getLeads(params?: LeadsParams): Promise<LeadsResponse> {
  return apiGet<LeadsResponse>('/leads', params as Record<string, unknown>);
}

export async function getLead(id: string): Promise<Lead> {
  return apiGet<Lead>(`/leads/${id}`);
}

export async function getLeadDetail(id: string): Promise<LeadDetail> {
  return apiGet<LeadDetail>(`/leads/${id}/detail`);
}

export async function updateLead(id: string, data: UpdateLeadData): Promise<Lead> {
  return apiPut<Lead>(`/site-admin/leads/${id}`, data);
}

export async function updateLeadStatus(id: string, status: LeadStatus): Promise<Lead> {
  return apiPut<Lead>(`/site-admin/leads/${id}`, { status });
}

export async function logLeadActivity(id: string, data: LogActivityData): Promise<LeadDetail> {
  return apiPost<LeadDetail>(`/leads/${id}/activities`, data);
}
